import { render, staticRenderFns } from "./TheMainContent.vue?vue&type=template&id=549e25e4"
import script from "./TheMainContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheMainContent.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports